export const TOP_WAVE_HEIGHT = 3 / 5;

export type PeaksOnlyWaveformProps = {
  // ignore data fetching and just display waveform for artist upload form
  uploadPeaks?: number[] | null;
  uploadDuration?: number;

  variant?: 'fullWidth' | 'contained';
  width?: number | string;
  height: number;
  barWidth?: number;
  barMargin?: number;

  displayTimes?: boolean;
  dateLabelText?: string;
};

export type BarCoordinatesArgs = {
  index: number;
  barWidth: number;
  maxBarHeight: number;
  minBarHeight?: number;
  barMargin: number;
  amplitude: number;
  containerHeight: number;
  topWaveHeight?: number;
};

export type Coordinate = {
  x: number;
  y: number;
  w: number;
  h: number;
};

export function barCoordinates({
  index,
  barWidth,
  maxBarHeight,
  barMargin,
  amplitude,
  containerHeight,
  topWaveHeight = TOP_WAVE_HEIGHT,
}: BarCoordinatesArgs): Coordinate {
  const currBarHeight = (amplitude / 100) * maxBarHeight;
  const verticalCenter = (containerHeight - currBarHeight) * topWaveHeight;

  return {
    x: index * (barWidth + barMargin),
    y: verticalCenter,
    w: barWidth,
    h: currBarHeight,
  };
}

export type RoundRectArgs = {
  ctx: CanvasRenderingContext2D;
  x: number;
  y: number;
  w: number;
  h: number;
  r: number;
};

export type PaintCanvasArgs = {
  canvasRef: React.RefObject<HTMLCanvasElement>;
  normalizedPeaks: number[];
  maxBarHeight: number;
  barWidth: number;
  barMargin: number;
  playingBarNum: number;
  hoverXCoord: number;
  isActiveTrack: boolean;
  unPlayedColor?: string;
  playedColor?: string;
  showBottomHalf?: boolean;
  topHalfHeight?: number;
  bottomHalfHeight?: number;
  gapHeight?: number;
  bottomHalfColor?: string;
  hoverColor?: string;
};

export function roundRect(args: RoundRectArgs) {
  const { ctx, x, y, w, h } = args;
  let { r } = args;

  if (w < 2 * r) r = w / 2;
  if (h < 2 * r) r = h / 2;

  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
  return ctx;
}

export type BarFillArgs = {
  ctx: CanvasRenderingContext2D;
  barWidth: number;
  maxBarHeight: number;
  unPlayedColor: string;
  playedColor: string;
  opacity: number;
  isHovering: boolean;
  withinHover: boolean;
  alreadyPlayed: boolean;
  isActiveTrack: boolean;
  isTopWave: boolean;
  bottomHalfColor?: string;
  hoverColor?: string;
};
